import * as React from 'react'
import Link from 'next/link'
import { FormattedMessage, useIntl } from 'react-intl'
import { isToday, startOfYesterday } from 'date-fns'
import { Article } from 'components/page'
import { Muted } from 'components/text'
import Head from 'components/Head'
import { useContext } from './context'
import Legacy from './Legacy'
import Layout from './Layout'
import Metadata from './Metadata'
import * as ShareUtils from 'utils/share'
import { DateParam } from '@avcan/utils/params'
import { DATE, TIME } from '@avcan/constants/intl/formats'
import * as TimeZoneNames from '@avcan/constants/timeZoneNames'
import styles from './Forecast.module.css'

export { default as Loop } from './Loop'
export { default as Image } from 'components/loop'

export default function WeatherForecast() {
    const { forecast } = useContext()
    const ogImage = ShareUtils.generateMWFOgImageUrl(forecast)
    const title = forecast?.headline

    return (
        <Article>
            <Head title={title} description={title} ogImage={ogImage} />
            <Metadata />
            {forecast ? <Forecast /> : <NoForecast />}
        </Article>
    )
}

// Utils
function Forecast() {
    const { forecast } = useContext()

    return (
        <section>
            <h2 className={styles.Headline}>{forecast.headline}</h2>
            {Array.isArray(forecast.outlook) ? <Legacy /> : <Layout />}
        </section>
    )
}
function NoForecast() {
    const { date } = useContext()
    const intl = useIntl()
    const publishTime = new Date()
    const values = {
        date: intl.formatDate(date, DATE),
    }

    publishTime.setHours(4, 0, 0, 0)

    return (
        <React.Fragment>
            <Muted>
                <FormattedMessage
                    description="Layout weather/forecast/Forecast"
                    defaultMessage="No weather forecast available yet for {date}"
                    values={values}
                />
            </Muted>
            {isToday(date) && (
                <Muted>
                    <FormattedMessage
                        description="Layout weather/forecast/Forecast"
                        defaultMessage="Weather forecasts are usually published at {publishTime} every day, <link>read yesterday's weather forecast</link>."
                        values={{
                            link(text) {
                                const to = DateParam.format(startOfYesterday())

                                return (
                                    <Link href={'/weather/forecast/' + to}>
                                        <a>{text}</a>
                                    </Link>
                                )
                            },
                            publishTime: intl.formatTime(publishTime, {
                                ...TIME,
                                timeZone: TimeZoneNames.AmericaVancouver,
                            }),
                        }}
                    />
                </Muted>
            )}
        </React.Fragment>
    )
}
